import { Mixpanel } from '@/utils/mixpanel';

import { getAllAutomationTriggers, getAllStages } from '../../services/stages.service';
import { FETCH_AUTOMATION_TRIGGER_SUCCESS, FETCH_STAGES_REQUEST, FETCH_STAGES_SUCCESS } from './stagesTypes';

export const fetchStagesRequest = () => {
  return {
    type: FETCH_STAGES_REQUEST,
  };
};

export const fetchStagesSuccess = (data) => {
  return {
    type: FETCH_STAGES_SUCCESS,
    payload: data,
  };
};

export const fetchAutomationTriggerSuccess = (data) => {
  return {
    type: FETCH_AUTOMATION_TRIGGER_SUCCESS,
    payload: data,
  };
};

const trackRelationshipStages = (allStages) => {
  if (!Array.isArray(allStages)) return;

  const stageProperties = {};

  allStages.forEach((stage) => {
    // Convert stage title to snake case for property name
    const propertyName = `rel_${stage.title.toLowerCase().replace(/\s+/g, '_')}`;
    stageProperties[propertyName] = stage.count || 0;
  });

  // Set all stage counts as user properties in Mixpanel
  Mixpanel.people.set(stageProperties);
};

export const fetchStages = () => {
  return async (dispatch) => {
    dispatch(fetchStagesRequest());
    const response = await getAllStages();
    if (response?.status) {
      const stages = response?.data?.allStages;
      dispatch(fetchStagesSuccess(stages));

      // Track relationship stages in Mixpanel
      trackRelationshipStages(stages);
    } else {
      dispatch(fetchStagesSuccess([]));
    }
  };
};

export const fetchAllStageTriggers = () => {
  return async (dispatch) => {
    const response = await getAllAutomationTriggers();
    if (response?.status) {
      dispatch(fetchAutomationTriggerSuccess(response?.data));
    } else {
      dispatch(fetchAutomationTriggerSuccess([]));
    }
  };
};
